









import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class UnifyList extends Vue {
  @Prop()
  public readonly noMargin?: any

  get showMargin() {
    return this.noMargin === undefined
  }
}
